<main class="main-dashboard">
    <article class="main-canvas">
        <section class="canvas-container">
            <section class="dashboard-items">
                <div class="canvas-item">
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6">
                            <div class="d-flex align-items-center">
                                <div class="edit">
                                    <button (click)="backToMyProjectV2()">
                                        <span><i class="ri-arrow-left-line"></i></span>
                                    </button>
                                </div>
                                <h3 class="px-3">My Project</h3>
                            </div>
                        </div>
                        <div class="col-sm-6 d-flex justify-content-end" *ngIf="this.isPMOLeadORManager || this.isPMOAdmin">
                            <div class="edit" *ngIf="selectedCheckboxData.length === 1">
                                <button type="button" title="Edit" (click)="editOpenModal()" data-bs-toggle="modal"
                                    data-bs-target="#projectV2Resource">
                                    <span><i class="ri-pencil-line"></i></span>
                                </button>
                            </div>
                            <div class="add-btn">
                                <button type="button" title="Create" (click)="createOpenModal()" data-bs-toggle="modal"
                                    data-bs-target="#projectV2Resource" class="btn btn-icon">
                                    <i class="ri-add-line"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6 d-flex" *ngIf="!this.parentProjectId">
                            <h3><a (click)="openProjectTab('myparameter-v2')">Details</a></h3>
                            <h3><a (click)="this.currentProjectId && openProjectTab('sub-project-v2')">Sub-Project</a></h3>
                            <h3><a (click)="this.currentProjectId && openProjectTab('task-v2')">Tasks</a></h3>
                            <h3><a class="active">Resources</a></h3>
                            <h3><a (click)="this.currentProjectId && openProjectTab('partlist')">Part List</a></h3>
                        </div>
                        <div class="title col-sm-6 d-flex" *ngIf="this.parentProjectId">
                            <h3><a (click)="this.currentProjectId && openProjectTab('sub-projectform-v2')">Sub-Project</a></h3>
                            <h3><a (click)="this.currentProjectId && openProjectTab('task-v2')">Tasks</a></h3>
                            <h3><a class="active">Resources</a></h3>
                        </div>
                    </div>
                    <ag-grid-angular
                        style="height: 620px;"
                        class="ag-theme-material"
                        (gridReady)="onGridReady($event)"
                        [rowData]="rowData"
                        [columnDefs]="columnDefs"
                        [pagination]="true"
                        [defaultColDef]="defaultColDef"
                        [suppressRowClickSelection]="true"
                        [rowSelection]="rowSelection"
                        (selectionChanged)="onSelectionChanged($event)"
                        [paginationPageSize]=10 >
                    </ag-grid-angular>
                </div>
            </section>
        </section>
    </article>
</main>

<!-- Create new Project Resource  -->
<div class="modal fade" id="projectV2Resource" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content pl-5 pr-5">
            <form [formGroup]="projectResourcesV2Form">
                <div class="modal-header">
                    <h5 class="modal-title">Create new Resources</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="input" *ngIf="modeAction === 1">
                        <div class="input-item no-overflow">
                            <ng-select formControlName="userName" [items]="userDropdownList"
                                [notFoundText]="'No employees found'" [multiple]="true" placeholder="Select User"
                                style="width: 100%; z-index: 1050; position: relative;">
                            </ng-select>
                            <label class="floating-label-special">User Name*</label>
                            <i class="ri-shield-user-line"></i>
                        </div>
                    </div>
                    <div class="input" *ngIf="modeAction === 2">
                        <div class="input-item no-overflow">
                            <input list="taskOwnerDatalist" formControlName="userName" placeholder="Applied For User"/>
                            <datalist id="taskOwnerDatalist">
                                <option [value]="item" *ngFor="let item of userDropdownList"></option>
                            </datalist>
                            <label class="floating-label-special">User Name*</label>
                            <i class="ri-shield-user-line"></i>
                        </div>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <select formControlName="projectRole" placeholder="Project Role">
                                <option value="" disabled selected>Project Role</option>
                                <option value="Creator" disabled>Creator</option>
                                <option value="Manager">Manager</option>
                                <option value="Lead">Lead</option>
                                <option value="User">User</option>
                            </select>
                            <label class="floating-label-special">Project Role*</label>
                            <i class="ri-shield-user-line"></i>
                        </div>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <select formControlName="projectAdminBoolean">
                                <option value="" disabled selected>Project Admin</option>
                                <option [ngValue]="true">Yes</option>
                                <option [ngValue]="false">No</option>
                            </select>
                            <label class="floating-label floating-label-special">Project Admin</label>
                            <i class="ri-shield-user-line"></i>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeCreateModal" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" (click)="createProjectV2Resource()" *ngIf="modeAction === 1">Assign Resource</button>
                    <button type="button" class="btn btn-primary" (click)="updateProjectV2Resource()" *ngIf="modeAction === 2">Save</button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Delete an item -->
<!-- <div class="modal fade" id="delete-items" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content pl-5 pr-5">
            <form action="">
                <div class="modal-header">
                    <h5 class="modal-title">Are you sure want to delete?</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="text-center">
                        <p>{{deleteConfirmationMsg}}?</p>
                    </div>
                </div>
                <div class="modal-footer">
                    <button id="closeModalDelete" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="selectedCheckboxData.length > 0" (click)="deleteProjectResource()">Yes Delete</button>
                </div>
            </form>
        </div>
    </div>
</div> -->